module.exports = "/work-site/img/angle.548f64df.png";